import { HORIZONTAL, NUMERIC, ENUMERATED, AGGREGATE, VARIABLE } from './constants';
import { REQUEST_DATE_FORMAT } from '../../../../constants';
import moment from 'moment';

export const checkVariableFieldForm = (variableFormData) => {
    let validationFlag = false
    if (variableFormData) {
        if (variableFormData.length === 0) {
            return true
        }
        for (let i = 0; i < variableFormData.length; i++) {
            if (variableFormData[i].fieldName && variableFormData[i].fieldType) {
                validationFlag = true;
            } else {
                validationFlag = false;
                break
            }
        }
    }
    return validationFlag
}
export const setVariableData = (variableData) => {
    variableData.forEach(data => {
        data.keyFieldType = VARIABLE
    })
    return variableData
}

export const setAggregateData = (aggregateData) => {
    aggregateData.forEach(data => {
        data.keyFieldType = AGGREGATE
    })
    return aggregateData
}

export const variableEnumeratedData = (variableData) => {
    variableData.forEach(data => {
        if (data.fieldType === "ENUMERATED") {
            const tempFieldValue = (data.fieldValue).toString();
            data.fieldValue = tempFieldValue;
        }
    })
    return variableData;
}
export const checkAggregateFieldForm = (aggregateFormData) => {
    if (aggregateFormData.length === 0) {
        return true
    }
    let validationFlag = false;
    for (let i = 0; i < aggregateFormData.length; i++) {
        if (aggregateFormData[i].fieldName && aggregateFormData[i].creditDropdown && aggregateFormData[i].fieldType && aggregateFormData[i].fieldDirection) {
            if (aggregateFormData[i].fieldDirection === HORIZONTAL) {
                if (aggregateFormData[i].toDate && aggregateFormData[i].fromDate) {
                    validationFlag = true
                } else {
                    validationFlag = false;
                    break
                }
            } else {
                validationFlag = true
            }
        } else {
            validationFlag = false;
            break
        }
    }
    return validationFlag
}
export const validatePaymentRiskGarde = (paymentRiskGrade) => {
    let validationFlag = false
    if (paymentRiskGrade) {
        if (paymentRiskGrade.length === 0) {
            return false
        }
        for (let i = 0; i < paymentRiskGrade.length; i++) {
            if (Object.keys(paymentRiskGrade[i]).length > 0) {
                if ((paymentRiskGrade[i].minScore) && (paymentRiskGrade[i].maxScore) && paymentRiskGrade[i].riskGrade && paymentRiskGrade[i].riskLevel && paymentRiskGrade[i].gradeDescription && (paymentRiskGrade[i].pd)) {
                    validationFlag = true;
                } else {
                    validationFlag = false;
                    break
                }
            } else {
                validationFlag = false;
                break
            }
        }
    }
    return validationFlag
}
export const checkMinimumField = (data) => {
    if (data.length === 0) {
        return true
    } else {
        return false
    }
}
export const creditWorthinessDropdownOptions = (variableFormData) => {
    let creditDropdown = [];
    variableFormData.map(variableData => {
        if (variableData.fieldType === NUMERIC) {
            creditDropdown.push(variableData);
        }
    })
    return creditDropdown;
}

export const createRequestBody = (variableFieldData, aggregateFieldData, levelTwoKeyFields, cugLevelTwoKeyFields, paymentRiskGrade, levelOneKeyFields, cugLevelOneKeyFields) => {
    let tempRequestBody = {
        fields: createVariableData(variableFieldData),
        aggregateFields: createAggregateData(aggregateFieldData, variableFieldData),
        levelOneKeyFields: createLevelOneBody(levelOneKeyFields),
        levelTwoKeyFields: levelTwoKeyFields,
        cugLevelOneKeyFields: createLevelOneBody(cugLevelOneKeyFields),
        cugLevelTwoKeyFields: cugLevelTwoKeyFields,
        riskGrades: paymentRiskGrade
    }

    return tempRequestBody

}
const createVariableData = (variableData) => {
    const tempData = [];
    variableData.forEach(data => {
        if (data.fieldType === NUMERIC) {
            tempData.push({
                id: (data.id) ? data.id : null,
                fieldName: data.fieldName,
                fieldType: data.fieldType,
                interpolated: data.interpolated
            })
        } else if (data.fieldType === ENUMERATED) {
            let tempValue = (data.fieldValue).split(",");
            tempData.push({
                id: (data.id) ? data.id : null,
                fieldName: data.fieldName,
                fieldType: data.fieldType,
                fieldValue: tempValue
            })
        } else {
            tempData.push({
                id: (data.id) ? data.id : null,
                fieldName: data.fieldName,
                fieldType: data.fieldType,
                fieldValue: []
            })
        }
    })
    return tempData
}

const createAggregateData = (aggregateData, variableData) => {
    const tempData = [];
    aggregateData.forEach(data => {
        tempData.push({
            id: (data.id) ? data.id : null,
            fieldName: data.fieldName,
            fieldType: data.fieldType,
            fieldDirection: data.fieldDirection,
            creditWorthinessField: getCreditDropdownId(data.creditDropdown, variableData),
            fromDate: (data.fieldDirection === HORIZONTAL) ? (moment(data.fromDate).format(REQUEST_DATE_FORMAT)).toUpperCase() : null,
            toDate: (data.fieldDirection === HORIZONTAL) ? (moment(data.toDate).format(REQUEST_DATE_FORMAT)).toUpperCase() : null
        })
    })
    return tempData
}
const getCreditDropdownId = (creditDropdownData, variableData) => {
    let tempCreditData;
    variableData.forEach(data => {
        if (data.fieldName === creditDropdownData) {
            tempCreditData = {
                fieldName: creditDropdownData,
                id: (data.id) ? data.id : null
            }
        }
    })
    return tempCreditData
}
const createLevelOneBody = (levelOneData) => {
    let tempData = [];
    levelOneData.forEach((data, index) => {
        tempData.push({
            id: (data.id) ? data.id : null,
            seqNum: index,
            fieldName: (data.fieldName) ? data.fieldName : data.label,
            keyFieldType: data.keyFieldType
        })
    })
    return tempData
}

export const setKeyField = (keyData) => {
    let tempKeyData = [];
    keyData.forEach((data, index, element) => {
        tempKeyData.push({
            id: data.id,
            seqNum: index,
            fieldName: data.fieldName,
            keyFieldType: data.keyFieldType
        })
    })
    return tempKeyData
}

export const setPredefinedType = (predefinedData, type) => {
    predefinedData.forEach(data => {
        data.keyFieldType = type
    })
    return predefinedData
}

export const setPaymentRiskGrade = (riskGrade) => {
    let tempData = [];
    riskGrade.forEach(data => {
        tempData.push({
            minScore: (data.minScore).toString(),
            maxScore: (data.maxScore).toString(),
            pd: (data.pd).toString(),
            riskGrade: data.riskGrade,
            riskLevel: data.riskLevel,
            gradeDescription: data.gradeDescription
        });
    })
    return tempData
}